<template>
  <section class="edit-container">
    <h2>Edit Referral Request</h2>
    <div class="abs-top-right">
      <v-button @click="$emit('cancel')">Cancel</v-button>
      <v-button
        type="primary"
        @click="handlerSave">Save</v-button>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
    >
      <div class="form-container">
        <div class="form-item">
          <!-- <span>Client Name</span> -->
          <el-form-item
            ref="name"
            prop="name"
            label="Client Name">
            <v-input
              v-model="formData.name" />
          </el-form-item>
          
        </div>
        <div class="form-item">
          <!-- <span>Client Contact Number</span> -->
          <el-form-item
            ref="phone"
            prop="phone"
            label="Client Contact Number">
            <v-input
              v-model="formData.phone"
              type="number"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <!-- <span>Product Type</span> -->
          <el-form-item
            ref="product_id"
            prop="product_id"
            label="Product Type">
            <v-select
              v-model="formData.product_id"
              :list="insuranceTypeOptions" />
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item
            ref="nick_name"
            prop="nick_name"
            label="Your Nickname">
            <v-input
              v-model="formData.nick_name" />
          </el-form-item>
          
        </div>
        <div class="form-item">
          <span>Remark</span>
          <v-input
            v-model="formData.remark"
            type="textarea"
            :rows="4" />
        </div>
        <h3>Supporting Doc.</h3>
        <section v-if="formData.other_file.length > 0">
          <file-container
            v-for="(item, index) in formData.other_file"
            :key="index"
            :fileData="item"
            :edit="true"
            :otherData="{
              index
            }"
            titleName= "Supporting Doc."
            @uploadSuccess="handlerUploadSuccess"
            @delete="deleteOtherFile">
          <!-- document{{ index+1 }} -->
          </file-container>
        </section>
        <v-upload
          @uploadSuccess="handlerUploadSuccess" />
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import FileContainer from '@/views/components/file-container'
import MixinRules from '@/mixins/rules'
import { editReferralRequest } from '@/api/request'
export default {
  name: 'EditReferralRequest',
  components: {
    FileContainer
  },
  mixins: [MixinOptions,MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    referralRequestId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        product_id: '',
        nick_name: '',
        remark: '',
        other_file: []
      },
      rules: {
        nick_name: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed: {
    insuranceTypeOptions() {
      return this.globalOptions.insurance_type.filter(item => item.id != 0)
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        // this.formData = Object.assign(this.formData, JSON.parse(JSON.stringify(val)))
        const data = JSON.parse(JSON.stringify(val))
        Object.keys(this.formData).some(key => {
          if(key in data) {
            this.formData[key] = data[key]
          }
        })
      }
    }
  },
  methods: {
    handlerSave() {
      this.$refs.form.validate((valid, rules) => {
        if (valid) {
          this.network().editReferralRequest()
        }else{
          this.scrollToValidDom(rules)
          this.$message({
            type: 'warning',
            message: '請填寫需填的信息'
          })
        }
      })
    },

    deleteOtherFile({ index }) {
      this.formData.other_file.splice(index, 1)
    },
    // 上傳完文件
    handlerUploadSuccess({ data, otherData }) {
      const { index = '' } = otherData
      const { name, id } = data
      if(index !== '') {
        this.$set(this.formData.other_file, index, data)
      }
      else {
        this.formData.other_file.push(data)
      }
    },
    network() {
      return {
        editReferralRequest: async () => {
          const { data } = await editReferralRequest({
            ...this.formData,
            id: this.referralRequestId
          })
          this.$emit('save')
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-container {
    position: relative;
    padding: 15px;
    .abs-top-right {
        top: 20px;
        right: 15px;
    }
    .form-container {
        width: 370px;
    }
}
</style>